/**
 * @author Phillip Stromberg, The Stromberg Group
 */
(function (lumonyx, $, undefined) {
    var light_on = true;
    var $img_lumonyx = $('img.lumonyx');

    function setLights(on) {
        var $body = $('body');
        var $toggles = $('.toggle-light');
        var $toggle_icons = $('.toggle-light .glyphicon');

        if (on) {
            $toggles.html($toggles.html().replace('Lights On', 'Lights Off'));
            $toggles.addClass('btn-success on');
            $toggles.removeClass('btn-danger');
            $body.animate({
                backgroundColor: '#eee'
            }, 500, 'swing', function() {
                $body.removeClass('no-bg');
            });
            $('#content').animate({
                backgroundColor: '#fff'
            });
            $body.removeClass('lights-off');
            $img_lumonyx.each(function() {
                var $this= $(this);
                var src = $this.attr('src');
                src = src.replace('-bl.jpg', '.jpg');
                $this.attr('src', src);
            });
        }
        else {
            $toggles.html($toggles.html().replace('Lights Off', 'Lights On'));
            $toggles.removeClass('btn-success on');
            $toggles.addClass('btn-danger');
            $toggle_icons.addClass('glyphicon-remove');
            $body.animate({
                backgroundColor: '#111'
            }, 500);
            $('#content').animate({
                backgroundColor: '#222'
            });
            $body.addClass('lights-off no-bg');
            $img_lumonyx.each(function() {
                var $this= $(this);
                var src = $this.attr('src');
                src = src.replace('.jpg', '-bl.jpg');
                $this.attr('src', src);
            });
        }
        light_on = on;
    }

    function preloadImages(sources) {
        for (var i = 0; i < sources.length; i++) {
            $("<img />").attr("src", sources[i]);
        }
    }

    function preloadLumonyxBacklightImages() {
        var sources = [];
        $img_lumonyx.each(function() {
            var src = $(this).attr('src');
            src = src.replace('.jpg', '-bl.jpg');
            sources.push(src);
        });
        preloadImages(sources);
    }

    // main function to start with
    lumonyx.main = function() {
        preloadLumonyxBacklightImages();
        $('.toggle-light, #product-image').click(function(e) {
            setLights(!light_on);
            e.preventDefault();
        });
        $('.hidden.toggle-light').removeClass('hidden');
    }

}(window.lumonyx = window.lumonyx || {}, jQuery));

window.addEventListener('DOMContentLoaded', function() {
    window.lumonyx.main();
});
